<template>
	<Col class="icon-container display-flex flex-justify-center">
		<AppTooltip :disabled="!hasTooltip" :tooltipText="tooltipText" v-if="iconName">
			<v-icon class="buttons-dropdown-icon" :color="iconColor">{{ iconName }}</v-icon>
			<div class="one-row" v-if="mainScreenText" :style="{ color: iconColor }">{{ mainScreenText }}</div>
		</AppTooltip>
	</Col>
</template>

<script>
export default {
	name: 'ButtonsDropdownIcon',
	props: {
		buttonDropdown: { type: Object },
	},
	computed: {
		iconColor() {
			return this.buttonDropdown.icon_color || '#000000';
		},
		iconName() {
			return this.buttonDropdown.icon_name;
		},
		tooltipText() {
			return this.buttonDropdown.tooltip_text;
		},
		hasTooltip() {
			return !!this.tooltipText;
		},
		mainScreenText() {
			return this.buttonDropdown.main_screen_text;
		},
	},
};
</script>

<style scoped lang="scss">
.icon-container {
	border-radius: 6px;
	border: 1px solid var(--border-color);
	max-width: 100px;
}
</style>
